import currentTimeZone from '../config/timeZone';

/**
 * Converts a local date and time (in 24-hour format) to a UTC ISO string.
 * @param {string} dateString - Date in 'YYYY-MM-DD' format
 * @param {string} timeString - Time in 'HH:mm' or 'HH:mm:ss' 24-hour format
 * @returns {string} UTC ISO string
 */
function ConvertDateTimeToUTC(dateString: string, timeString: string): string {
  if (dateString === '') {
    return '';
  }

  let finalTimeString = timeString;
  if (timeString === '') {
    finalTimeString = '00:00';
  }

  const fullTime = finalTimeString.length === 5 ? `${finalTimeString}:00` : finalTimeString;
  const localDateTimeString = `${dateString}T${fullTime}`;

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: currentTimeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date(localDateTimeString));

  const dateParts: Record<string, string> = {};
  /* eslint-disable no-restricted-syntax */
  for (const part of parts) {
    if (part.type !== 'literal') {
      dateParts[part.type] = part.value;
    }
  }

  const utcDate = new Date(
    Date.UTC(
      Number(dateParts.year),
      Number(dateParts.month) - 1,
      Number(dateParts.day),
      Number(dateParts.hour),
      Number(dateParts.minute),
      Number(dateParts.second),
    ),
  );

  return utcDate.toISOString();
}

export default ConvertDateTimeToUTC;
